import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Collapse, Row, Form as AntForm } from 'antd';
import { Form, Field } from 'react-final-form';
import { sellingAgreementsFilterFields } from '../../constants/formAccountGOSSellingAgreementsFilter';
import { ClassificatorField, YearSelect } from '../../atoms';
import AutoCompleteAccountsRegCodeField from '../../components/AutoCompleteAccountsField/AutoCompleteAccountsRegCodeField';
import { FormActions } from '../../components';
import PropTypesImmutable from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { downloadFileByPostURL } from '../../utils/files';
import { fuelType } from '../../constants/classificators';
import {
  getAllowedBiofuelTypes,
  getAllowedFuelTypes,
} from '../TradingPlatformAgreementsFilter/TradingPlatformAgreementsFilter';
import FormStateToRedux from '../FormStateToRedux';
import {
  updateFormState,
  formValueSelector,
} from '../../reducers/reactFinalFormReducer';

const { Panel } = Collapse;

const yearSelect = (field) => {
  return (
    <AntForm.Item label={field.label} layout="vertical">
      <YearSelect
        {...field.input}
        onChange={(value) => field.input.onChange(value)}
        beforeCurrent={false}
        afterCurrent={true}
        placeholder={field.placeholder}
        yearDistance={5}
      />
    </AntForm.Item>
  );
};

export class AccountGOSAgreementsFilter extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    filterValues: PropTypesImmutable.map,
    initialValues: PropTypes.object,
    counterparty: PropTypes.string.isRequired,
    csvUrl: PropTypes.string.isRequired,
    csvFilename: PropTypes.string.isRequired,
    csvButton: PropTypes.string.isRequired,
    form: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
    updateFormState: PropTypes.func.isRequired,
  };

  lastUsedFilters = {};

  componentDidMount() {
    const { initialValues, updateFormState, form } = this.props;
    this.lastUsedFilters = initialValues;
    if (initialValues) {
      updateFormState(form, { values: initialValues });
    }
  }

  handleCsvExport = () => {
    downloadFileByPostURL(
      this.props.csvUrl,
      this.lastUsedFilters,
      this.props.csvFilename + '.csv'
    );
  };

  handleFuelTypeChange = (form) => {
    form.change(sellingAgreementsFilterFields.FUEL_GENERATION, null);
  };

  onClear = (form) => {
    const { initialValues, updateFormState, form: formName } = this.props;
    form.restart(initialValues);
    updateFormState(formName, { values: initialValues });
  };

  render() {
    const {
      t,
      counterparty,
      filterValues,
      initialValues,
      onSubmit,
      form: formName,
    } = this.props;

    return (
      <React.Fragment>
        <Form
          onSubmit={onSubmit}
          initialValues={initialValues}
          render={({ handleSubmit, form }) => (
            <Collapse>
              <Panel
                key="agreements-filter"
                header={t('agreements.filter.panelTitle')}
              >
                <form onSubmit={handleSubmit}>
                  <FormStateToRedux form={formName} />
                  <Row gutter={24}>
                    <Col span={8}>
                      <Field
                        name={sellingAgreementsFilterFields.STATUS}
                        label={t('agreements.filter.status')}
                        component={ClassificatorField}
                        classificatorType={ClassificatorField.types.tsStatus}
                        hasFeedback={false}
                      />
                    </Col>
                    <Col span={8}>
                      <Field
                        name={counterparty}
                        label={t('agreements.filter.counterParty')}
                        component={AutoCompleteAccountsRegCodeField}
                        hasFeedback={false}
                      />
                    </Col>
                    <Col span={8}>
                      <Field
                        name={
                          sellingAgreementsFilterFields.FINAL_CONSUMPTION_YEAR
                        }
                        label={t('agreements.filter.finalConsumptionYear')}
                        placeholder={t('agreements.filter.selectYear')}
                        component={yearSelect}
                        hasFeedback={false}
                      />
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={8}>
                      <Field
                        name={sellingAgreementsFilterFields.FUEL_TYPE}
                        label={t('agreements.filter.fuelType')}
                        component={ClassificatorField}
                        classificatorType={ClassificatorField.types.tsFuelType}
                        hasFeedback={false}
                        onChange={() => this.handleFuelTypeChange(form)}
                        allowed={getAllowedFuelTypes()}
                      />
                    </Col>
                    {filterValues?.toJS().fuelType !==
                      fuelType.RENEWABLE_ELECTRICITY && (
                      <Col span={8}>
                        <Field
                          name={sellingAgreementsFilterFields.FUEL_GENERATION}
                          label={t('agreements.filter.fuelGeneration')}
                          component={ClassificatorField}
                          classificatorType={
                            ClassificatorField.types.biofuelType
                          }
                          hasFeedback={false}
                          allowed={getAllowedBiofuelTypes(
                            filterValues?.toJS().fuelType
                          )}
                        />
                      </Col>
                    )}
                    <Col span={8}>
                      <Field
                        name={sellingAgreementsFilterFields.AGREEMENT_TYPE}
                        label={t('agreements.filter.agreementType')}
                        component={ClassificatorField}
                        classificatorType={
                          ClassificatorField.types.agreementType
                        }
                        hasFeedback={false}
                      />
                    </Col>
                  </Row>
                  <FormActions>
                    <Button onClick={() => this.onClear(form)}>
                      {t('transactions.filter.clearBtn')}
                    </Button>
                    <Button
                      onClick={() =>
                        (this.lastUsedFilters = this.props.filterValues)
                      }
                      type="primary"
                      htmlType="submit"
                    >
                      {t('transactions.filter.submitBtn')}
                    </Button>
                  </FormActions>
                </form>
              </Panel>
            </Collapse>
          )}
        />
        <FormActions>
          <Button onClick={() => this.handleCsvExport()}>
            {this.props.csvButton}
          </Button>
        </FormActions>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, props) => ({
  filterValues: formValueSelector(props.form)(state),
});

const mapDispatchToProps = {
  updateFormState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountGOSAgreementsFilter);
